import { Navigate, Outlet, Route, Routes } from 'react-router-dom'

import { Box, Stack } from '@mui/material'

import { MAIN_HEADER_HEIGHT } from '@/layouts/main'

import NetworkPage from '@/pages/network/NetworkPage'
import CreateNetworkPage from '@/pages/create-network/CreateNetworkPage'

import DiscoverNetworks from './components/DiscoverNetworks'
import InvitationNetworks from './components/InvitationNetworks'
import JoinedNetworks from './components/JoinedNetworks'
import NetworksNavDrawer from './components/NetworksNavDrawer'
import { useIsMobile } from '@/hooks/useSizeBreakpoints'
import MobileNetworksNavDrawer from './components/MobileNetworksNavDrawer'
import MobileNetworkPage from '../network/MobileNetworkPage'

export default function NetworksPage() {
  const isMobile = useIsMobile()
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Stack direction="row" flex={1} maxHeight={`calc(100vh - ${MAIN_HEADER_HEIGHT}px)`}>
            {isMobile ? <MobileNetworksNavDrawer /> : <NetworksNavDrawer />}
            <Box overflow="auto">
              <Outlet />
            </Box>
          </Stack>
        }
      >
        <Route path="discover" element={<DiscoverNetworks />} />
        <Route path="invitations" element={<InvitationNetworks />} />
        <Route path="joins" element={<JoinedNetworks />} />
        <Route index element={<Navigate to="/networks/joins" />} />
        {isMobile && <Route path="create" element={<CreateNetworkPage />} />}
      </Route>
      {!isMobile && <Route path="create" element={<CreateNetworkPage />} />}
      <Route path=":networkId/*" element={isMobile ? <MobileNetworkPage /> : <NetworkPage />} />
    </Routes>
  )
}
